import styled from "styled-components";

const Wrapper = styled.aside`
  @media (min-width: 1200px) {
    display: none;
  }
  .sidebar-container {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.85);
    display: none;
    justify-content: center;
    align-items: center;
    z-index: -1;
    transition: var(--transition);
  }
  .show-sidebar {
    display: flex;
    z-index: 99;
  }
  .content {
    background-color: rgba(0, 0, 0, 0.5);
    width: 100vw;
    height: 100vh;
    border-radius: var(--borderRadius);

    padding-top: 8rem;

    position: fixed;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .close-btn {
    position: absolute;
    top: 1.2rem;
    left: 1.2rem;
    background: transparent;
    border-color: transparent;
    font-size: 2rem;
    color: var(--white);
    cursor: pointer;
  }
  .nav-links {
    display: flex;
    flex-direction: column;
  }
  .nav-link {
    display: flex;
    align-items: center;
    color: var(--white);
    padding: 1rem 0;
    text-transform: capitalize;
    transition: var(--transition);
  }
  .nav-link:hover {
    color: var(--grey-900);
  }
  .nav-link:hover .icon {
    color: var(--primary-500);
  }
  .icon {
    font-size: 1.5rem;
    margin-right: 1rem;
    display: grid;
    place-items: center;
    transition: var(--transition);
  }
  .active {
    color: var(--white);
  }
  .active .icon {
    color: var(--white);
  }
`;
export default Wrapper;
